module.exports = __webpack_public_path__ + "static/media/twitterIcon.079ff124.svg";